import { Button } from "@/components/ui/button";

import {
  FILTER_LABELS,
  IMAGE_TRIAGE_FILTERS,
  type ImageTriageFilter,
} from "./imageTriageUtils";

export function ImageTriageFilters({
  value,
  onChange,
}: {
  value: ImageTriageFilter;
  onChange: (value: ImageTriageFilter) => void;
}) {
  return (
    <div
      className="flex flex-wrap gap-2"
      aria-label="Image preprocessing filters"
    >
      {IMAGE_TRIAGE_FILTERS.map((filter) => (
        <Button
          key={filter}
          type="button"
          size="sm"
          variant={value === filter ? "secondary" : "outline"}
          aria-pressed={value === filter}
          onClick={() => onChange(filter)}
        >
          {FILTER_LABELS[filter]}
        </Button>
      ))}
    </div>
  );
}
